/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import Num = alm.util.Num;
	import DeviceInfo = alm.browser.DeviceInfo;

	export class RouteLine extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(track:Track, zoomLevel:number, terrain:Terrain) {
			super();

			this.track = track;
			this.zoomLevel = zoomLevel;
			this.terrain = terrain;

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			// Line
			this.material = new THREE['LineMaterial']({
				color: 0xffff00,
				linewidth: DeviceInfo.getIsDesktop() ? 0.002 : 0.004,
				//vertexColors: THREE.VertexColors,
				dashed: false,
			});

			// vertexColors
			//const assetLoader = AssetLoader.getInstance();
			//const track = assetLoader.getTrack();
			//const colorMap = assetLoader.getSpeedColorMap();
			//const minSpeed = track.getMinSpeed();
			//const maxSpeed = track.getMaxSpeed();
			//const speedColors:number[] = [];

			const points:TrackPoint[] = this.track.getPoints();
			const pointCount:number = points.length;
			const positions:number[] = [];
			for (let i:number = 0; i < pointCount; ++i) {
				if (i % 4 == 0) {
					const point:TrackPoint = points[i];

					const latLng:LatLng = point.getPosition();
					latLng.calcPixelCoord(this.zoomLevel);
					const position = Unit.pixelElevationToSpace(latLng.getPixel(), point.getElevation(), this.zoomLevel);
					positions.push(position.x, position.y + 1, position.z);
					//positions.push(position.x, this.terrain.getY(position.x, position.z) + 10, position.z);

					// vertexColors
					//const color = colorMap.getColor(Num.map(point.getSpeed(), minSpeed, maxSpeed, 0.5, 1));
					//speedColors.push(color.r / 255, color.g / 255, color.b / 255);
				}
			}

			this.geometry = new THREE['LineGeometry']();
			this.geometry.setPositions(positions);

			// vertexColors
			//this.geometry.setColors(speedColors);

			const line = new THREE['Line2'](this.geometry, this.material);
			line.computeLineDistances();
			line.scale.set(1, 1, 1);
			return line;





			/*
			// Tube
			this.material = new THREE.MeshBasicMaterial( {
				color: 0xffff00,
			});

			const pathPoints:THREE.Vector3[] = [];

			const points:TrackPoint[] = this.track.getPoints();
			const pointCount:number = points.length;
			for (let i:number = 0; i < pointCount; ++i) {
				const point:TrackPoint = points[i];

				const position:LatLng = point.getPosition();
				position.calcPixelCoord(this.zoomLevel);
				const position3 = Unit.pixelElevationToSpace(position.getPixel(), point.getElevation(), this.zoomLevel);

				pathPoints.push(position3);
			}

			const path = new THREE.CatmullRomCurve3(pathPoints);
			this.geometry = new THREE.TubeGeometry(path, pointCount / 2, 3, 3, false);
			trace('[RouteLine] vertex count :', this.geometry.attributes.position.count);

			return new THREE.Mesh(this.geometry, this.material);
			*/





			// Line
			/*
			this.material = new THREE.LineBasicMaterial({
				color: 0xffffff,
				transparent: false,
				linewidth: 3,
				linecap: 'round',
				linejoin: 'round',
			});

			this.geometry = new THREE.Geometry();
			const points:TrackPoint[] = this.track.getPoints();
			const pointCount:number = points.length;
			for (let i:number = 0; i < pointCount; ++i) {
				const point:TrackPoint = points[i];

				const position:LatLng = point.getPosition();
				position.calcPixelCoord(this.zoomLevel);
				const pixel:THREE.Vector2 = position.getPixel();
				const x:number = pixel.x;
				const y:number = Unit.meterToPixel(point.getElevation(), this.zoomLevel) * Config.terrainElevationMaxScale;
				const z:number = pixel.y;

				this.geometry.vertices.push(new THREE.Vector3(x, y, z));
			}

			return new THREE.Line(this.geometry, this.material);
			*/
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = true;
			});
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = false;
			});
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private track:Track;
		private zoomLevel:number;
		private terrain:Terrain;

		private material:any;
		private geometry:any;

		//private material:THREE.MeshBasicMaterial;
		//private geometry:THREE.TubeBufferGeometry;

		//private material:THREE.LineBasicMaterial;
		//private geometry:THREE.Geometry;
	}
}
